export default __webpack_public_path__ + "images/5a3f7da34e86254c8b1033692c9e62fe-2_4K_1920x544.webp";